/* tslint:disable */
export var icon = "\n<svg width=\"61\" height=\"97\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"1.26\" y=\".5\" width=\"59\" height=\"96\" rx=\"3.5\" fill=\"#fff\" stroke=\"#DAEFFE\"/></svg>\n";
//# sourceMappingURL=widget-theme-edgy.svg.js.map